import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { getColumnWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserCommon';

export const getMerchandiserPlaceholderGap = (
  height: number
): GridCard<PlaneTypes.Layout_Merchandiser> => {
  const width = getColumnWidth();

  // @ts-expect-error
  return getGap({
    width,
    height,
  });
};
